import { UrlConstants } from "../url.constants";
export class ApiTimeoutConstants {
    static URL = UrlConstants.API_V2 + "Timeout";
    static UpdateTimeoutTimer = "UpdateTimeoutTimer";
    static FUNCTION_POST_CONTINUE_TIMEOUT_TIMER = "ContinueTimeouts";
    static FUNCTION_POST_PAUSE_TIMEOUT_TIMER = "PauseTimeouts";
    static FUNCTION_GET_STOP_TIMEOUT_TIMERS = "GetStopTimeoutTimers";
    static FUNCTION_GET_AWAIT_TIMEOUT_TIMERS = "GetAwaitTimers";
    static FUNCTION_GET_DISTINCT_TIMEOUT_STATUS = "GetDistinctTimeoutStatus";
}
